import React from "react";
import { Create, SimpleForm, TextInput, required } from "react-admin";
import { Typography } from "@material-ui/core";

export function CountryCreate(props: any): JSX.Element {
  return (
    <Create {...props} mutationMode="pessimistic">
      <SimpleForm>
        <Typography variant="h6">Create Country</Typography>
        <TextInput source="name" validate={[required()]} fullWidth />
        <TextInput
          source="isoCode"
          label="Country Code"
          validate={[required()]}
          helperText="ISO 3166-1 alpha-2 two-letter country code (e.g. 'US', 'GB', 'DE')"
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
}
